export default __webpack_public_path__ + "static/img_growing_together_3-7245d265087359ed2ab0605887c0ea1b.png";